package com.ervasstudio.tracoemovimento.pages.home

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.sections.Logos
import com.ervasstudio.tracoemovimento.util.Res
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.*

@Composable
fun MainSection(isMobile: Boolean = false) {
    Column(modifier = Modifier.fillMaxWidth()) {
        Box(
            modifier = Modifier.fillMaxWidth().position(Position.Relative),
            contentAlignment = Alignment.Center
        ) {
            Image(
                modifier = Modifier.fillMaxWidth().objectFit(ObjectFit.Cover),
                src = Res.Image.grid,
            )

            Image(
                modifier = Modifier
                    .width(if (isMobile) 22.cssRem else 40.cssRem)   // era 40.cssRem
                    .objectFit(ObjectFit.Contain),
                src = Res.Image.akin,
            )

            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                HeroLine(text = "ONDE O DESENHO", isMobile = isMobile)
                HeroLine(
                    text = "GANHA VIDA",
                    isMobile = isMobile,
                    marginTop = if (isMobile) 4.px else 10.px,
                )
            }
        }
        Logos(isMobile = isMobile)
    }
}